<template>
  <gj-modal
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      padding20
      type="info"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>删除标签分类</template>
    <template #content>
      <div class="content">
        <p>
          执行标签分类删除操作后，系统将自动删除当前对象的所有下级标签分类、以及当前对象和其下级标签分类关联的所有标签数据，确定删除？
        </p>
        <p>标签分类：{{item.label | defaultShow}}</p>
        <p>下级分类数量：2个</p>
        <p style="margin: 0;">关联标签数量：25个</p>
      </div>
    </template>
  </gj-modal>
</template>

<script>

  import {modalMixIn} from "../../../../../minxins";

  export default {
    name: "app-tag-group-delete-modal",
    mixins: [modalMixIn],
    props: {
      item: {
        type: Object
      }
    },
    data() {
      return {
        confirmLoading: false,
      }
    },
    methods: {
      confirm() {
        this.confirmLoading = true;
        setTimeout(() => {
          this.modalVisible = false;
          this.confirmLoading = false;
        }, 500);
      }
    }
  }
</script>

<style scoped>
  .content {
    font-size: 12px;
  }
  .content p:not(:last-child) {
    margin: 0 0 8px;
  }
</style>

